<template lang="pug">
  b-modal#updateCMCF(
    ref="updateCMCF"
    :title="$t('ui.combine.update_commission')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="md"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive.commission
        table.table.table-bordered
          tbody
            tr
              th {{ comm_cockfight_title }}
              td
                PTSelect(
                  ref="comm_cockfight"
                  :dirty="$v.comm_cockfight.$dirty"
                  :error="$v.comm_cockfight.$error"
                  :options="comm_cockfight_options"
                  v-model="$v.comm_cockfight.$model"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import { required, maxValue } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      loading: false,
      comm_cockfight: 0,
      submission: {
        success: true,
        status: ""
      }
    }
  },
  validations: {
    comm_cockfight: {
      required,
      maxValue(value) {
        return maxValue(this.comm_cockfight_max)(value)
      }
    }
  },
  computed: {
    editLimit: function() {
      return [config.accessRoles.editLimit]
    },
    comm_cockfight_title: function() {
      return this.$t("ui.esports2") + " (" + this.comm_cockfight_max + ")"
    },
    comm_cockfight_max: function() {
      return this.$store.getters.getCommCF
    },
    comm_cockfight_options: function() {
      return this.$helpers.getCommRateList1(this.comm_cockfight_max, this.comm_cockfight)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    getChildCommission: function() {
      $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      let account_id = this.accountId
      let platform_code = "COCKFIGHT"
      if(account_id) {
        this.$store
        .dispatch("user/getChildCommission", { account_id, platform_code })
        .then(response => {
          this.$v.comm_cockfight.$model = response.data.cm[0].account_commission
          $("select").prop("disabled", !this.$helpers.getVisible(this.editLimit))
        })
        .catch(response => {
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_commission_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateCommCF()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_commission_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateCommCF: function() {
      let account_id = this.accountId
      let account_commission = this.comm_cockfight
      this.$store
        .dispatch("user/updateCommissionCF", { account_id, account_commission })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_commission_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updateCommissionLC", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.comm_cockfight = 0
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getCommission()
        this.getChildCommission()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updateCMCF.hide()
    }
  }
};
</script>

